import {
  getFullAccessActionName, FULL_ACCESS_ACTION_NAMES,
} from '@wix/wix-vod-shared/src/widget/ui-selectors/video-access';

const getBuyClickHandler = ({ purchaseFn, subscribeFn, videoItem, channelData }) => {
  const status = getFullAccessActionName(channelData, videoItem);

  if (status === FULL_ACCESS_ACTION_NAMES.SUBSCRIBE) {
    return subscribeFn;
  } else if (status) {
    return purchaseFn;
  }
};

export default getBuyClickHandler;



// WEBPACK FOOTER //
// ./src/widget/utils/get-buy-click-handler.js